import React from 'react';
import {useHistory, useParams} from 'react-router-dom';
import * as yup from 'yup';
import {useFormik} from 'formik';
import {Form, Message, Input} from 'semantic-ui-react';
import {useResetPasswordMutation} from 'api';
import styled from 'styled-components';
import {PositiveButton} from '../../../components/mypage/MypageLayout';

const validationSchema = yup.object().shape({
  password: yup
    .string()
    .trim()
    .min(6, 'パスワードは６文字以上で設定してください。')
    .required('パスワードを入力してください'),
  passwordConfirmation: yup
    .string()
    .trim()
    .required('パスワード(確認)を入力してください')
    .oneOf([yup.ref('password'), null], 'パスワードが一致していません'),
});

export default () => {
  const history = useHistory();
  const {token} = useParams<{token: string}>();

  const [resetPassword, {data, loading}] = useResetPasswordMutation({
    onCompleted: (data) => {
      if (!data?.resetPassword?.error) {
        history.push('/registration/success');
      }
    },
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirmation: '',
      token,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      resetPassword({
        variables: {input: values},
      });
    },
  });

  return (
    <Container>
      <Title>パスワードの再設定</Title>

      {data?.resetPassword?.error && (
        <Message negative>
          <p>{data.resetPassword.error}</p>
        </Message>
      )}

      <div className="description">
        <p>変更するパスワードを入力してください。</p>
      </div>

      <Form onSubmit={formik.handleSubmit}>
        <div className="field">
          <label>新しいパスワード</label>
          <Input
            name="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.password && formik.errors.password && (
            <Message negative>{formik.errors.password}</Message>
          )}
        </div>

        <div className="field">
          <label>新しいパスワード(確認)</label>
          <Input
            name="passwordConfirmation"
            type="password"
            value={formik.values.passwordConfirmation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.passwordConfirmation &&
            formik.errors.passwordConfirmation && (
              <Message negative>{formik.errors.passwordConfirmation}</Message>
            )}
        </div>

        <Actions>
          <PositiveButton
            positive
            type="submit"
            size="large"
            disabled={loading || !formik.isValid}>
            送信
          </PositiveButton>
        </Actions>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 90px;
  text-align: center;
  width: 400px;
  margin: 0 auto;

  .description {
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 12px;
    line-height: 1.5;
    color: #2c2c2c;

    p {
      margin-bottom: 0;
    }
  }

  .border {
    font-size: 13px;
    margin: 40px 0;
    height: 1px;
    border-top: solid 1px #999999;
    position: relative;

    p {
      position: absolute;
      top: -10px;
      left: 39%;
      background-color: #fff;
      width: 80px;
      text-align: center;
    }
  }

  label {
    text-align: left;
    opacity: 0.37;
    color: #333333;
    font-size: 12px;
  }

  input[type='email'],
  input[type='password'] {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 45px;
    background-color: #f5f5f5;
    border: solid 1px #f1f1f1;
  }

  .links {
    margin: 15px 0;
    text-align: left;
    font-size: 12px;
    line-height: 1.17;

    a {
      color: #ef5350;
    }
  }

  .submit {
    margin: 40px;
  }
`;

const Title = styled.h1`
  margin-bottom: 70px;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #666666;
`;

const Actions = styled.div`
  margin: 60px 0;

  button {
    width: 100%;
  }
`;
